// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__HeLbE","alertIcon":"ConfirmModal_alertIcon__Pq72K"};